/*  MUI  */
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@mui/material';
import { Permission } from 'application/Shared/Components/Core';
import { FontSizes } from 'application/Shared/Constants';

/*  Helpers */
import { Transition } from 'application/Shared/Helpers';

/*  React  */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AddAdminUser } from './AddAdminUser';
import { LinkAnmTenant } from './LinkAnmTenant';
import { TenantActions } from './TenantActions';
import { TenantDangerZone } from './TenantDangerZone';
import { TenantFeatureFlags } from './TenantFeatureFlags';
import { UpdateWorkatoManifest } from './UploadWorkatoManifest';

export const EditTenantModal = ({ open, onCloseFn, tenant, rerenderFn }) => {
    const [tenantHasChanged, setTenantHasChanged] = useState();
    const { name, id } = tenant;

    const { t } = useTranslation();

    const onSuccessFn = () => setTenantHasChanged(true);
    const onClose = () => {
        onCloseFn();
        if (tenantHasChanged && rerenderFn) {
            rerenderFn();
        }
    };

    const canEditAnmLinkSettings = !!tenant.partner;

    const isClientTenant = !tenant.partner;

    return (
        <Dialog
            data-trackid="editPartnerModalDialog"
            fullScreen
            PaperProps={{ style: { padding: 0 } }}
            onClose={onClose}
            open={open}
            TransitionComponent={Transition}
        >
            <DialogTitle sx={{ backgroundColor: 'background.tertiary' }}>
                <Box>{name}</Box>
                <Box sx={{ fontSize: FontSizes[2], fontWeight: 400 }}>
                    ID: {id}
                </Box>
            </DialogTitle>
            <DialogContent
                dividers
                sx={{ backgroundColor: 'background.primary' }}
            >
                <TenantActions tenant={tenant} onSuccessFn={onSuccessFn} />
                <TenantFeatureFlags tenant={tenant} onSuccessFn={onSuccessFn} />
                {canEditAnmLinkSettings && (
                    <LinkAnmTenant tenant={tenant} onSuccessFn={onSuccessFn} />
                )}
                <AddAdminUser tenant={tenant} onSuccessFn={onSuccessFn} />

                {isClientTenant && (
                    <Permission required="super_admin">
                        <UpdateWorkatoManifest tenant={tenant} />
                    </Permission>
                )}

                <Permission required="super_admin">
                    <TenantDangerZone
                        tenant={tenant}
                        onSuccessFn={onSuccessFn}
                    />
                </Permission>
            </DialogContent>
            <DialogActions>
                <Button
                    data-trackid="globalAdmin_tenant_edit_close"
                    color="primary"
                    variant="contained"
                    style={{ float: 'right' }}
                    onClick={onClose}
                >
                    {t('Common.close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
